import { Modal } from "react-bootstrap";
import {Col, Row, Button} from "antd";
import React from "react";
import warning from "../../Assets/Images/warning.png";

//css

function DeleteModal(props) {
  return (
    <div>
      <Modal show={props.show} onHide={props.onHide} size="lg" centered>
        <Modal.Header />
        <Modal.Body className="">
          <div className="text delete-modal-content">
            <Row className="d-flex justify-content-center"><h1> WARNING! </h1></Row>
            <Row className="">
              <Col xs={6} className="d-flex justify-content-center"><img src={warning} alt="warning" className="warning-icon"/></Col>
              <div className="text-group">
                <h2>
                  Are you sure you want to{" "}
                  {props.isCancel ? "cancel" : "delete"} this {props.text}?
                </h2>
                <h3>
                  {" "}
                  The {props.text}’s details will be deleted immediately.
                </h3>
                <h3>You can’t undo this action. </h3>
                {props.isCancel && (
                  <input
                    type="text"
                    name="reason"
                    className="reason-modal-input"
                    placeholder="State reason"
                    onChange={(e) => props.setReason(e.target.value)}
                  />
                )}
              </div>
            </Row>
            {/* <Row className=" pt-4">
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col
                className="cancel-btn text-center me-1"
                onClick={props.onHide}
              >
                {props.isCancel ? "CLOSE" : "CANCEL"}
              </Col>
              <Col className="save-btn text-center" onClick={props.onDelete}>
                {props.isCancel ? "PROCEED" : "DELETE"}
              </Col>
            </Row> */}

            <Row className="mt-4 d-flex justify-content-end">
                <Col xs={12}>
                <Row className=" w-100">
                  <Col xs={12}>
                      <Button
                        className="w-100"
                        onClick={props.onHide}
                      >
                        CLOSE
                      </Button>
                  </Col>
                  <Col xs={12}>
                    <Button
                      className="w-100"
                      onClick={props.onDelete}
                      danger
                    >
                      DELETE
                    </Button>
                  </Col>
                </Row>
                </Col>
              </Row>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

DeleteModal.defaultProps = {
  text: "",
  // type:"",
  // size: "lg",
  show: () => {},
  onHide: () => {},
  onDelete: () => {},
};

export default DeleteModal;
